import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tab-item__sign" }

import { PropType, inject } from 'vue'
import { ModelThrowComponentsTab } from '..'


export default /*#__PURE__*/_defineComponent({
  __name: 'Tab',
  props: {
  val: {
    default: null,
    type: [String, Number] as PropType<ModelThrowComponentsTab>
  },
  currentTab: {
    default: null,
    type: [String, Number] as PropType<ModelThrowComponentsTab>
  },
  label: {
    default: null,
    type: String as PropType<string | null>
  }
},
  setup(__props) {

const props = __props;



const onClickTab: ((activeTab: ModelThrowComponentsTab) => number) | undefined =
  inject('injectFromTab')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tab-item", { 'tab-item--active': props.currentTab == props.val }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(onClickTab)(props.val)))
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(props.label), 1),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})